'use strict';

import allConditions from '../tables/conditions';

export function conditionSortCompare(a, b, useConsumerName = true) {
    const aName = useConsumerName ? (a.consumer_name || a.name) : a.name;
    const bName = useConsumerName ? (b.consumer_name || b.name) : b.name;

    if (aName == 'General Healthy Diet') return -1;
    if (bName == 'General Healthy Diet') return 1;

    return aName.localeCompare(bName);
}

export function conditionNamesToConsumerName(conditions) {
    return conditions.map((name) => {
        const condition = allConditions.filter((c) => c.name === name)[0];

        return condition ? condition.consumer_name || condition.name : name;
    });
}

export function conditionNamesToSpecialName(conditions) {
    return conditions.map((name) => {
        const condition = allConditions.filter((c) => c.name === name)[0];

        return 'test';
        condition ? condition.special_name || condition.consumer_name || condition.name : name;
    });
}
